var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 55,
    viewBox: "0 0 149 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2643_56482)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2643_56482)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2643_56482",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 0,
    width: 119,
    height: 55
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.979 0H15.6797V54.0671H133.979V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2643_56482)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2643_56482",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 0,
    width: 119,
    height: 55
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.979 0H15.6797V54.0671H133.979V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2643_56482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.2656 42.5457V42.2048H75.9553V36.8233H75.2656V36.4845H79.0359V36.2275H79.4588V37.6896H79.0448V36.9073H76.8669V39.2585H78.6039V38.5651H79.0246V40.3744H78.6039V39.6721H76.8669V42.1343H79.129V41.325H79.5497V42.5457H75.2656Z",
    fill: "#172342",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.575 36.8255V42.6457H103.182L99.6553 37.7963V42.2047H100.355V42.5456H98.5029V42.2047H99.1986V37.1736L98.9508 36.8255H98.3164V36.4844H99.8285L103.113 40.986V36.8255H102.416V36.4844H104.261V36.8255H103.575Z",
    fill: "#172342",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4021 42.6637C92.7151 42.6637 91.3828 41.2313 91.3828 39.5239C91.3828 37.7959 92.7058 36.375 94.4021 36.375C96.0688 36.375 97.3941 37.8073 97.3941 39.517C97.3941 41.2244 96.0685 42.6637 94.4021 42.6637ZM94.4113 36.8526C93.2086 36.8526 92.3968 37.9552 92.3968 39.517C92.3968 41.0679 93.2083 42.1863 94.4021 42.1863C95.5775 42.1863 96.3799 41.0584 96.3799 39.517C96.3799 37.9733 95.5775 36.8526 94.4113 36.8526Z",
    fill: "#172342",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5445 42.5456V42.2047H72.2321V37.6895L69.9822 42.6365L67.619 37.587V42.2047H68.317V42.5456H66.4629V42.2047H67.1575V36.8232H66.4629V36.4844H68.0885L70.2096 41.0112L72.2957 36.4844H73.8349V36.8232H73.145V42.2047H73.8349V42.5456H71.5445Z",
    fill: "#172342",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.168 42.5456V42.2047H81.8569V36.8232H81.168V36.4844H83.4596V36.8232H82.7707V42.1341H84.9239V41.3249H85.3445V42.5456H81.168Z",
    fill: "#172342",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.459 42.5456V42.2047H87.1479V36.8232H86.459V36.4844H88.7509V36.8232H88.0619V42.1341H90.2173V41.3249H90.6379V42.5456H86.459Z",
    fill: "#172342",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3158 36.8227L60.5527 39.6988V42.2042H61.2495V42.5451H58.9578V42.2042H59.6478V39.7555L57.7415 36.8227H57.2129V36.4863H59.5875V36.8227H58.8191L60.3595 39.185L61.7931 36.8227H60.955V36.4863H62.7909V36.8227H62.3158Z",
    fill: "#172342",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9766 39.3606C48.6315 39.4334 49.6203 39.82 49.6203 40.9679C49.6203 41.9365 48.8475 42.5456 47.7493 42.5456H44.8086V42.2047H45.4984V36.8232H44.8086V36.4844H47.588C48.5554 36.4844 49.326 37.0094 49.326 37.9896C49.326 38.7944 48.6315 39.2514 47.9766 39.3399V39.3606ZM47.2288 36.9072H46.4126V39.1945H47.1788C47.7495 39.1945 48.3666 38.8375 48.3666 38.0257C48.3666 37.228 47.8607 36.9072 47.2288 36.9072ZM47.2653 39.6084H46.4126V42.1341H47.2653C48.0359 42.1341 48.6805 41.7182 48.6805 40.9203C48.6802 40.0927 48.079 39.6084 47.2653 39.6084Z",
    fill: "#172342",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9333 36.8255V42.6457H55.5423L52.016 37.7963V42.2047H52.7127V42.5456H50.8579V42.2047H51.5579V37.1736L51.3101 36.8255H50.6758V36.4844H52.1866L55.4742 40.986V36.8255H54.7761V36.4844H56.6223V36.8255H55.9333Z",
    fill: "#172342",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.542 16.8916C74.2657 18.1022 72.2376 19.6813 70.5664 21.3363C72.1967 22.9358 74.0963 24.467 76.542 25.7799L87.9075 21.3363L76.542 16.8916Z",
    fill: "#172342",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8317 20.5827C67.2762 17.8659 65.5356 14.8181 64.6582 12.248L76.2185 16.7668C74.1332 17.6135 71.9096 18.9071 69.8317 20.5827Z",
    fill: "#172342",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8317 22.0889C67.2762 24.8059 65.5356 27.8546 64.6582 30.4255L76.2185 25.905C74.1332 25.0593 71.9096 23.7656 69.8317 22.0889Z",
    fill: "#172342",
    fillOpacity: 0.6
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2643_56482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148.33,
    height: 54.33,
    fill: "white",
    transform: "translate(0.664062)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2643_56482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148.33,
    height: 54.33,
    fill: "white",
    transform: "translate(0.664062)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg5);
export default __webpack_public_path__ + "static/media/img5.2ddaa6d52d72a9342d72052a3980d2c6.svg";
export { ForwardRef as ReactComponent };